// extracted by mini-css-extract-plugin
export default {"wrapper":"Partners_wrapper__19f+U","full":"Partners_full__117YH","separator":"Partners_separator__8bG5g"};